namespace $.$$ {

	$mol_style_define( $shm_service_task_menu, {
	} )

}
